<template>
  <div class="AsideButton">
    
      <el-popover
          placement="right"
          width="150"
          trigger="hover">
          <div class="icon" slot="reference">
            <img class="play" src="@/common/images/leveing/video/side-phone.png" alt="手机查看">
            <p>手机查看</p>
          </div>
          <div class="asideqrcode">
            <img  :src="mobileQrcode" alt="视频图片">
            <p>微信扫一扫，手机看直播</p>
          </div>
      </el-popover>

      <el-popover
          placement="right"
          width="150"
          trigger="hover">
          <div class="icon" slot="reference">
            <img class="play" src="@/common/images/leveing/video/side-img.png" alt="生成海报">
            <p>生成海报</p>
          </div>
          <div class="asideqrcode">
            <img  :src="vliveEventposterQrcode" alt="生成海报">
            <p>微信扫一扫，生成海报</p>
          </div>
      </el-popover>

      <el-popover v-if="detailsList.isopenmp == 1"
          placement="right"
          width="150"
          trigger="hover">
          <div class="icon" slot="reference">
            <img class="play" src="@/common/images/leveing/video/side-vx.png" alt="公众号">
            <p>公众号</p>
          </div>
          <div class="asideqrcode">
            <img :src="detailsList.mpqratturl" alt="公众号">
            <p>微信扫一扫，关注公众号</p>
          </div>
      </el-popover>
      <!-- 公众号 后台配置获取，没配置不展示 -->

      <div class="icon" v-if="detailsList.isopenenroll">
        <img class="play" src="@/common/images/leveing/video/side-add.png" alt="报名参与" @click="goto(detailsList.enrollurl)">
        <p>报名参与</p>
      </div>
      <!-- 报名参与 后台配置获取，没配置不展示 -->
  </div>
  <!-- end 视频直播 侧边状态按钮 -->
</template>

<script>
import { mapActions } from 'vuex'
import { getVliveEventposter } from 'api/pcvideo.js'
import {urlToQRCode} from 'common/js/tools'

export default {
  name: 'AsideButton',
  props: ['detailsList'],
  data () {
    return {
      innerid: this.$route.query.innerid,
      vliveEventposterQrcode: "", // 海报二维码
      mobileQrcode: ""  // 手机查看二维码
    }
  },
  mounted () {
    this.getVliveEventposter()

    this.phoneQrcode()
  },
  methods: {
    goto(enrollurl) {  // 报名
      window.open(enrollurl, '_blank')
    },
    phoneQrcode() { // 生成手机二维码
      let host = this.$router.resolve({
        name: 'MliveDetails',
        query: {liveid: this.$route.query.innerid}
      })
      this.mobileQrcode = urlToQRCode(window.location.origin + host.href)
      // console.log(window.location.origin + host.href)
    },
    getVliveEventposter () {  // 获取海报
    //   this.setLoading(true)
      getVliveEventposter({
        data: {innerid: this.innerid},
        success: data => {
        //   this.setLoading(false)
          this.vliveEventposterQrcode = urlToQRCode(data.data.eventposteratturl)
        },
        error: () => {
        //   this.setLoading(false)
          // this.$message.error(data.msg)
        }
      })
    },
    ...mapActions(['setLoading'])
  },
  filters: {},
  watch: {},
  computed: {},
  components: {}
}
</script>

<style lang="scss" type="text/scss">
.el-popper[x-placement^=right] {
  margin-top: -11px;
}
.asideqrcode {
      img {
        display: block;
        margin: auto;
        margin-bottom: 8px;
        width: 100px;
        height: 100px;
      }
      p {
        font-size: 12px;
        text-align: center;
      }
     
    }
.AsideButton {
    position: fixed;
    z-index: 2;
    margin-left: -80px;
    top: 258px;
    .icon {
      width: 56px;
      margin-bottom: 30px;
      cursor: pointer;
      img {
        display: block;
        margin: auto;
        width: 42px;
        height: 42px;
      }
      p {
        margin-top: 8px;
        color: #666;
        font-size: 14px;
        text-align: center;
      }
    }
}
</style>